/* eslint-disable */
const isUS =  process.env.REACT_APP_STORE === 'culture-kings-us.myshopify.com';
export default {
  "general": {
    "meta": {
      "tags": "Tagged \"{{ tags }}\"",
      "page": "Page {{ page }}"
    },
    "404": {
      "title": "404 Page Not Found",
      "subtext_html": "The page you requested does not exist. Click <a href=\"\/\">here<\/a> to continue shopping."
    },
    "breadcrumbs": {
      "home": "Home",
      "home_link_title": "Back to the frontpage"
    },
    "newsletter_form": {
      "newsletter_email_html": "<i class=\"icon icon-star\"><\/i> Sign up for <b>exclusive<\/b> email updates and weekly drops.",
      "submit": "Sign up",
      "newsletter_confirmation": "Thanks for joining!",
      "newsletter_email": "Enter email to join"
    },
    "search": {
      "no_results_html": "Your search for \"{{ terms }}\" did not yield any results.",
      "results_for_html": "Your search for \"{{ terms }}\" revealed the following:",
      "title": "Search for products on our site",
      "placeholder": "Search brands or products",
      "submit": "Search"
    }
  },
  "blogs": {
    "article": {
      "author_on_date_html": "{{ author }} &middot; {{ date }}",
      "older_post": "Older Post",
      "newer_post": "Newer Post",
      "tags": "Tags",
      "comment_meta_html": "{{ author }} on {{ date }}",
      "read_more": "Read more"
    },
    "comments": {
      "title": "Leave a comment",
      "name": "Name",
      "email": "Email",
      "message": "Message",
      "post": "Post comment",
      "moderated": "Please note, comments must be approved before they are published",
      "success_moderated": "Your comment was posted successfully. We will publish it in a little while, as our blog is moderated.",
      "success": "Your comment was posted successfully! Thank you!",
      "with_count": {
        "one": "{{ count }} comment",
        "other": "{{ count }} comments"
      }
    },
    "sidebar": {
      "recent_articles": "Recent Articles",
      "categories": "Categories"
    }
  },
  "cart": {
    "general": {
      "title": "Shopping Cart",
      "remove": "Remove",
      "note": "Special instructions for seller",
      "subtotal": "Subtotal",
      "customs_tax": "Estimated Import Tax",
      "shipping_at_checkout": "Shipping & taxes calculated at checkout",
      "update": "Update Cart",
      "checkout": "Proceed to checkout",
      "continue_shopping": "Continue shopping",
      "empty": "Your cart is currently empty.",
      "close_cart": "Close Cart",
      "savings_html": "You're saving {{ price }}"
    },
    "label": {
      "product": "Product",
      "price": "Price",
      "quantity": "Quantity",
      "total": "Total"
    }
  },
  "collections": {
    "general": {
      "all_of_collection": "All {{ collection }}",
      "no_matches": "Sorry, we couldn't find any products",
      "link_title": "Browse our {{ title }} collection",
      "grid_view": "Grid view",
      "list_view": "List view",
      "items_with_count": {
        "one": "{{ count }} item",
        "other": "{{ count }} items"
      }
    },
    "sidebar": {
      "tags": "Filters"
    },
    "sorting": {
      "title": "Sort by",
      "featured": "Featured",
      "best_selling": "Best Selling",
      "az": "Alphabetically, A-Z",
      "za": "Alphabetically, Z-A",
      "price_ascending": "Price, low to high",
      "price_descending": "Price, high to low",
      "date_descending": "Date, new to old",
      "date_ascending": "Date, old to new"
    },
    "onboarding": {
      "modal_title": "This page will show all of your store's products",
      "no_products_html": "There are no products yet, but once you begin adding them they will show up here regardless if they are in a collection.",
      "add_product": "Add Product"
    }
  },
  "contact": {
    "form": {
      "name": "Name",
      "email": "Email",
      "phone": "Phone Number",
      "message": "Message",
      "send": "Send",
      "post_success": "Thanks for contacting us. We'll get back to you as soon as possible."
    }
  },
  "customer": {
    "account": {
      "title": "My Account",
      "details": "Account Details",
      "view_addresses": "View Addresses",
      "return": "Return to Account Details"
    },
    "activate_account": {
      "title": "Activate Account",
      "subtext": "Create your password to activate your account.",
      "password": "Password",
      "password_confirm": "Confirm Password",
      "submit": "Activate Account",
      "cancel": "Decline Invitation"
    },
    "addresses": {
      "title": "Your Addresses",
      "default": "Default",
      "add_new": "Add a New Address",
      "edit_address": "Edit address",
      "first_name": "First Name",
      "last_name": "Last Name",
      "company": "Company",
      "address1": "Address1",
      "address2": "Address2",
      "city": "City",
      "country": "Country",
      "province": "Province",
      "zip": "Postal\/Zip Code",
      "phone": "Phone",
      "set_default": "Set as default address",
      "add": "Add Address",
      "update": "Update Address",
      "cancel": "Cancel",
      "edit": "Edit",
      "delete": "Delete"
    },
    "login": {
      "title": "Login",
      "email": "Email",
      "password": "Password",
      "forgot_password": "Forgot your password?",
      "sign_in": "Sign In",
      "cancel": "Return to Store",
      "guest_title": "Continue as a guest",
      "guest_continue": "Continue"
    },
    "orders": {
      "title": "Order History",
      "order_number": "Order",
      "date": "Date",
      "payment_status": "Payment",
      "fulfillment_status": "Status",
      "total": "Total",
      "none": "You haven't placed any orders yet."
    },
    "order": {
      "title": "Order {{ name }}",
      "date": "Placed on {{ date }}",
      "cancelled": "Order Cancelled on {{ date }}",
      "cancelled_reason": "Reason: {{ reason }}",
      "billing_address": "Billing Address",
      "payment_status": "Payment Status",
      "shipping_address": "Shipping Address",
      "fulfillment_status": "Fulfillment Status",
      "discount": "Discount",
      "shipping": "Shipping",
      "tax": "Tax",
      "product": "Product",
      "sku": "SKU",
      "price": "Price",
      "quantity": "Quantity",
      "total": "Total",
      "fulfilled_at": "Fulfilled {{ date }}",
      "subtotal": "Subtotal"
    },
    "recover_password": {
      "title": "Reset your password",
      "email": "Email",
      "submit": "Submit",
      "cancel": "Cancel",
      "subtext": "We will send you an email to reset your password.",
      "success": "We've sent you an email with a link to update your password."
    },
    "reset_password": {
      "title": "Reset account password",
      "subtext": "Enter a new password for {{ email }}",
      "password": "Password",
      "password_confirm": "Confirm Password",
      "submit": "Reset Password"
    },
    "register": {
      "title": "Register Now",
      "first_name": "First Name",
      "last_name": "Last Name",
      "email": "Email",
      "password": "Password",
      "submit": "Register",
      "cancel": "Return to Store"
    }
  },
  "layout": {
    "navigation": {
      "menu": "Menu"
    },
    "drawers": {
      "browse": "Browse",
      "close_menu": "Close menu"
    },
    "cart": {
      "title": "Cart",
      "items_count": {
        "one": "item",
        "other": "items"
      }
    },
    "customer": {
      "account": "Your Account",
      "logged_in_as_html": "<span class=\"mobile-nav__logged-in\">Logged in as<\/span> {{ first_name }}",
      "log_out": "Sign Out",
      "log_in": "Sign In",
      "create_account": "Register"
    },
    "footer": {
      "social_title": "Get Connected",
      "accepted_payments": "Accepted Payments",
      "social_platform": "{{ name }} on {{ platform }}"
    }
  },
  "products": {
    "general": {
      "previous_product_html": "&larr; Previous Product",
      "next_product_html": "Next Product &rarr;",
      "sale_price": "Sale price",
      "regular_price": "Regular price"
    },
    "product": {
      "pre_sale": "Pre Order Now",
      "sold_out": "Sold Out",
      "sold_out_online": "Sold Out Online",
      "on_sale": "On Sale",
      "on_sale_from_html": "<strong>On Sale<\/strong> from <span class=\"js-price\">{{ price }}<\/span>",
      "unavailable": "Unavailable",
      "compare_at": "",
      "quantity": "Quantity",
      "add_to_cart": "Add to Cart",
      "add_bundle_to_cart": "Add Bundle to Cart",
      "bundle_unavailable": "Bundle is unavailable",
      "wearing_text": "{{ name }} is {{ height }} and is wearing a size {{ size }}."
    }
  },
  "marketing": {
    "afterpay_cta": {
      "title_text": "Make {{ afterpay_payment_increments }} fortnightly payments and receive your order now"
    }
  },
  "gift_cards": {
    "issued": {
      "title": "Here's your {{ value }} gift card for {{ shop }}!",
      "subtext": "Here's your gift card!",
      "disabled": "Disabled",
      "expired": "Expired on {{ expiry }}",
      "active": "Expires on {{ expiry }}",
      "redeem": "Use this code at checkout to redeem your gift card",
      "shop_link": "Start shopping",
      "print": "Print",
      "add_to_apple_wallet": "Add to Apple Wallet"
    }
  },
  "date_formats": {
    "month_day_year": "%b %d, %Y"
  },
  "shopify": {
    "checkout": {
      "contact": {
        "city_label": "Suburb\/City",
        "city_placeholder": "Suburb\/City",
        "optional_address2_label": "Apartment, Unit, etc"
      }
    }
  },
  "stores": {
    "brisbane": {
      "phone": "0732114838",
      "state_code": "qld",
      "address": "181 ELIZABETH ST",
      "map_url": "https:\/\/goo.gl\/maps\/Hm26vmtHg1K2"
    },
    "goldcoast": {
      "phone": "0755922062",
      "state_code": "qld",
      "address": "LEVEL 1, PACIFIC FAIR SHOPPING CENTRE",
      "map_url": "https:\/\/goo.gl\/maps\/NJqcT2ZAUJR2"
    },
    "sydney": {
      "phone": "0292320473",
      "state_code": "nsw",
      "address": "420 GEORGE ST",
      "map_url": "https:\/\/goo.gl\/maps\/BaNVWAwx4Ju"
    },
    "melbourne": {
      "phone": "0396497005",
      "state_code": "vic",
      "address": "1 QUEEN STREET",
      "map_url": "https:\/\/goo.gl\/maps\/hfUguY5UAYt"
    },
    "chadstone": {
      "phone": "0395648382",
      "state_code": "vic",
      "address": "CHADSTONE SHOPPING CENTRE",
      "map_url": "https:\/\/goo.gl\/maps\/4WpghdMVZVv"
    },
    "gold-coast": {
      "phone": "0755922062",
      "state_code": "qld",
      "address": "LEVEL 1, PACIFIC FAIR SHOPPING CENTRE",
      "map_url": "https:\/\/goo.gl\/maps\/DtbAKnXYKWT2"
    },
    "perth": {
      "phone": "0755922062",
      "state_code": "wa",
      "address": "664 HAY STREET",
      "map_url": "https:\/\/goo.gl\/maps\/4SszKZ5VoLw"
    }
  },
  "models": {
    "angelito": {
      "height": "175cm",
      "wears": "Angelito is 175cm and typically wears large tops and 30-32\" bottoms."
    },
    "michael": {
      "height": "191cm",
      "wears": "Michael is 191cm tall and typically wears an Extra Large (XL) top and 34\" bottoms."
    },
    "tyrell": {
      "height": "171cm",
      "wears": "Tyrell is 171cm tall and typically wears a Medium top and 32\" bottoms."
    },
    "steve": {
      "height": "180cm",
      "wears": "Steve is 180cm tall and typically wears a Large top and 32\" bottoms."
    },
    "jb": {
      "height": "190cm",
      "wears": "JB is 190cm tall and typically wears a Medium top and 32\" bottoms."
    },
    "dave": {
      "height": "173cm",
      "wears": "Dave is 173cm tall and typically wears a Medium top and 30\" bottoms."
    },
    "john": {
      "height": "167cm",
      "wears": "John is 167cm tall and typically wears a Medium top and 32\" bottoms."
    },
    "josh": {
      "height": "180cm",
      "wears": "Josh is 180cm tall and typically wears Large tops and 32\" bottoms."
    },
    "justin": {
      "height": "198cm",
      "wears": "Justin is 198cm tall and typically wears a Large top and 32\" bottoms."
    },
    "nic": {
      "height": "175cm",
      "wears": "Nic is 175cm tall and typically wears a Large top and 32\" bottoms."
    },
    "tom": {
      "height": "190cm",
      "wears": "Tom is 190cm tall and typically wears a Large top."
    },
    "brad": {
      "height": "185cm",
      "wears": "Brad is 185cm tall and typically wears a Large top and 32\" bottoms."
    },
    "dela": {
      "height": "179cm",
      "wears": "Dela is 179cm tall and usually wears a size 30 in bottoms and a size medium in tops."
    }
  },
  "ck": {
    "sizing": {
      "true_size": "True to size"
    },
    "brand": {
      "10-deep": "10 Deep",
      "125th": "125th",
      "1992-nineteen-92": "1992 (nineteen 92)",
      "40-s-and-shorties": "40's And Shorties",
      "40oz-nyc": "40oz Nyc",
      "4hunnid":"4HUNNID",
      "47-brand": "47 Brand",
      "9five": "9five",
      "aaa-allstyle": "Aaa (all Style)",
      "abc": "Abc",
      "a-bathing-ape":"A Bathing Ape",
      "acapulco-gold-co": "Acapulco Gold Co.",
      "adidas": "Adidas",
      "adidas-originals": "Adidas Originals",
      "adidas-performance": "Adidas Performance",
      "akomplice": "Akomplice",
      "alife": "Alife",
      "alpha": "Alpha Industries",
      "american-apparel": "American Apparel",
      "american-needle": "American Needle",
      "american-stitch-llc": "American Stitch Llc",
      "american-thrift": "American Thrift",
      "ampal-creative": "Ampal Creative",
      "android": "Android",
      "apothecary87": "Apothecary 87",
      "armourdillo": "Armourdillo",
      "as-colour": "As Colour",
      "asap-mob": "ASAP Mob",
      "asap-mob-apparel": "ASAP Mob Apparel",
      "asap-rocky-apparel": "ASAP Rocky Apparel",
      "asphalt-yacht-club": "Asphalt Yacht Club",
      "assorted-brands": "Assorted Brands",
      "atlanta-curls": "Atlanta Curls",
      "aura-gold": "Aura Gold",
      "baby-g": "Baby G",
      "barney-cools": "Barney Cools",
      "beardbrand": "Beardbrand",
      "beats-by-dre": "Beats By Dre",
      "billie-eilish": "Billie Eilish",
      "billionaire-boys-club": "Billionaire Boys Club",
      "black-apple": "Black Apple",
      "black-boy-place": "Black Boy Place",
      "black-kaviar": "Black Kaviar",
      "black-pyramid": "Black Pyramid",
      "black-scale": "Black Scale",
      "black-sox-ink": "Black Sox Ink",
      "bloodbath": "Bloodbath",
      "bob-marley": "Bob Marley",
      "booger-kids": "Booger Kids",
      "boy-london": "Boy London",
      "bravado": "Bravado",
      "breezy": "Breezy",
      "brian-lichtenberg": "Brian Lichtenberg",
      "brick-city-villin": "Brick City Villin",
      "brixton": "Brixton",
      "brumby-sunstate": "Brumby Sunstate",
      "broken-promises": "Broken Promises",
      "brooklyn-mint": "Brooklyn Mint",
      "brutal-truth": "BRUTAL TRUTH",
      "burner": "Burner",
      "cahill": "Cahill +",
      "calvin-klein": "Calvin Klein",
      "medicom-toy": "Medicom Toy",
      "caravagio-clothing": "Caravagio Clothing",
      "carhartt": "Carhartt",
      "carre": "Carre",
      "cashletes": "Cashletes",
      "crocs": "Crocs",
      "trippie-redd": "Trippie Redd",
      "casio": "Casio",
      "caviar-cartel": "Caviar Cartel",
      "champion": "Champion",
      "champion-blanks": "Champion Blanks",
      "chinga-clothing": "Chinga Clothing",
      "chuck-original": "Chuck Original",
      "circle-park": "Circle Park",
      "civil-clothing": "Civil Clothing",
      "civil-regime": "Civil Regime",
      "ckm-music-merch": "Ckm Music Merch",
      "clarks-originals": "Clarks Originals",
      "class-of-99": "Class Of 99",
      "common-goods": "Common Goods",
      "converse": "Converse",
      "crap": "Crap",
      "criminal-damage": "Criminal Damage",
      "crep": "Crep",
      "crooks-and-castles": "Crooks and Castles",
      "cross-colours-la": "Cross Colours LA",
      "crysp-denim": "Crysp Denim",
      "culture-kings": "Culture Kings",
      "culture-kings-custom": "Culture Kings Custom",
      "dad-hat": "Dad Hat",
      "d-e-collective": "D.E Collective",
      "dead-studios": "Dead Studios",
      "decky": "Decky",
      "defend-paris": "Defend Paris",
      "denman": "Denman",
      "denzel-curry": "Denzel Curry",
      "detache": "Detache Labs",
      "dgk": "Dgk",
      "diamond-cuts": "Diamond Cuts",
      "diamond-supply": "Diamond Supply",
      "dickies": "Dickies",
      "dipset-usa": "Dipset Usa",
      "dim-mak": "Dim Mak",
      "dirty-jax": "Dirty Jax",
      "district-goods": "District Goods",
      "dnine-reserve": "Dnine Reserve",
      "dope": "Dope",
      "down-town-ny": "Down Town Ny",
      "draft-day": "Draft Day",
      "drake-scorpion-merch": "Drake scorpion",
      "dr-martens": "Dr Martens",
      "durkl": "Durkl",
      "dvnt": "Dvnt",
      "dxpe-chef": "DXPE Chef",
      "eastpak": "Eastpak",
      "edwin": "Edwin",
      "elevn-clothing-co": "Elevn Clothing Co",
      "ellesse": "Ellesse",
      "embellish": "Embellish",
      "eminem": "Eminem",
      "emperor-apparel": "Emperor Apparel",
      "en-noir-inc": "En Noir Inc",
      "entree": "Entree",
      "eptm": "Eptm",
      "escapism": "Escapism",
      "eternity-bc-ad": "Eternity BC\/AD",
      "ewing-athletics": "Ewing Athletics",
      "f-a-t-s": "F.a.t.s",
      "f2d": "F2d",
      "fairplay": "Fairplay",
      "famous": "Famous",
      "federation": "Federation",
      "fila": "Fila",
      "five-each": "Five Each",
      "flat-fitty": "Flat Fitty",
      "flexfit": "Flexfit",
      "flud-watches": "Flud Watches",
      "fly-society": "Fly Society",
      "forte": "Forte",
      "foundation-footwear": "Foundation Footwear",
      "franks-chop-shop": "Franks Chop Shop",
      "franks-house": "Franks House",
      "fully-laced": "Fully Laced",
      "g-shock": "G Shock",
      "global-merchandising": "Global Merchandising",
      "goat-crew": "Goat Crew",
      "goat-crew-junior": "Goat Crew Junior",
      "gods-masterful-children": "Gods Masterful Children",
      "golden-denim": "Golden Denim",
      "golfwang": "Golfwang",
      "good-wood": "Good Wood",
      "gourmet": "Gourmet",
      "guess": "Guess",
      "guess-originals": "Guess Originals",
      "grand-scheme": "Grand Scheme",
      "gravis": "Gravis",
      "grizzly": "Grizzly",
      "hall-of-fame": "Hall Of Fame",
      "han-cholo": "Han Cholo",
      "hardware-london": "Hardware London",
      "hater": "Hater",
      "haus-of-jr": "Haus Of Jr",
      "heel-bruise": "Heel Bruise",
      "herschel-bag-co": "Herschel Bag Co",
      "hex": "Hex",
      "homme-femme": "Homme Femme",
      "house-of-auric": "HOUSE OF AURIC",
      "hstry": "Hstry",
      "hudson-nyc": "Hudson Nyc",
      "huf": "Huf",
      "huffer": "Huffer",
      "ice-cube": "Ice Cube",
      "ichiban": "Ichiban",
      "ilabb": "Ilabb",
      "illest": "Illest",
      "im-king": "Im King",
      "incase": "Incase",
      "iridium-clothing-co": "Iridium Clothing Co.",
      "ivy-park": "Ivy Park",
      "jaden-smith": "Jaden Smith",
      "jase-new-york": "Jase New York",
      "jason-markk": "Jason Markk",
      "jordan": "Jordan",
      "just-hype": "Just Hype",
      "justin-bieber": "Justin Bieber",
      "k-swiss": "K-swiss",
      "kappa": "Kappa",
      "karl-kani": "Karl Kani",
      "kangol": "Kangol",
      "karter-collection": "Karter Collection",
      "kennedy-denim-co": "Kennedy Denim Co",
      "king-apparel": "King Apparel",
      "kingbrown": "Kingbrown",
      "kiss-chacey": "Kiss Chacey",
      "kloude-clothing": "Kloude Clothing",
      "konkreet": "Konkreet",
      "korin": "Korin",
      "kr3w": "Kr3w",
      "lacespace": "LaceSpace",
      "lacoste": "Lacoste",
      "l-a-t-h-c": "L.a.t.h.c",
      "lapse": "Lapse",
      "last-kings": "Last Kings",
      "lb2-little-yachty": "LB2 Lil Yachty",
      "led-zeppelin": "Led Zeppelin",
      "lemar-dauley": "Lemar & Dauley",
      "levi-strauss-and-co": "Levi Strauss And Co",
      "lifted-anchors": "Lifted Anchors",
      "lil-homme": "Lil Homme",
      "lil-wayne": "Lil Wayne",
      "lil-yachty": "Lil Yachty",
      "lira": "Lira",
      "local-supply": "Local Supply",
      "loiter-nyc": "Loiter NYC",
      "loiter-squad": "Loiter Squad",
      "los-angeles-radyo": "Los Angeles Radyo",
      "lower": "Lower",
      "lrg": "Lrg",
      "lura-eyewear-llc": "Lura Eyewear",
      "magic-city": "Magic City",
      "majestic-athletic": "Majestic Athletic",
      "manic-books": "Manic Books",
      "meister": "Meister",
      "melin": "Melin",
      "metallica": "Metallica",
      "michael-jackson": "Michael Jackson",
      "migos": "Migos",
      "mighty-healthy": "Mighty Healthy",
      "midnight-city": "Midnight City",
      "milkcrate-athletics": "Milkcrate Athletics",
      "misc": "Misc",
      "mishka": "Mishka",
      "mister": "Mister",
      "mitchell-and-ness": "Mitchell and Ness",
      "modern-pirate": "Modern Pirate",
      "motivation": "Motivation",
      "mr-simple": "Mr Simple",
      "msfts": "MSFTSrep",
      "music-merch": "Music Merch",
      "mxim": "MXiM",
      "mystery": "Mystery",
      "nana-judy": "Nana Judy",
      "nba": "Nba",
      "neff": "Neff",
      "nena-and-pasadena": "Nena and Pasadena",
      "new-balance": "New Balance",
      "new-era": "New Era",
      "new-era-ek": "New Era Ek",
      "new-era-x-afl": "New Era X Afl",
      "new-era-x-nrl": "New Era X Nrl",
      "new-slaves": "New Slaves",
      "nhl": "Nhl",
      "nike": "Nike",
      "nike-sb": "Nike SB",
      "nixon": "Nixon",
      "no-country": "No Country",
      "notorious-b-i-g": "NOTORIOUS B.I.G",
      "nv-euro": "Nv Euro",
      "n-w-a": "N.W.A",
      "obey": "Obey",
      "odd-future": "Odd Future",
      "odd-sox": "Odd Sox",
      "onitsuka": "Onitsuka",
      "opal": "Opal",
      "orchill": "Orchill",
      "orisue": "Orisue",
      "other-uk-clothing-limited": "Other Uk Clothing Limited",
      "otzi": "Ötzi",
      "oysters-on-a-half-sh": "Oysters On A Half Sh",
      "paislee": "Paislee",
      "palladium": "Palladium",
      "patagonia": "Patagonia",
      "penfield": "Penfield",
      "penny-australia": "Penny Australia",
      "phantom-project": "Phantom Project",
      "pink-dolphin": "Pink Dolphin",
      "pink-floyd": "Pink Floyd",
      "playboi": "Playboi",
      "playcloths": "Playcloths",
      "pointer": "Pointer",
      "post-malone": "Post Malone",
      "prince": "Prince",
      "probity-merch": "Probity Merch",
      "proclub": "Proclub",
      "prolific": "Prolific",
      "publish": "Publish",
      "puma": "Puma",
      "quay-australia": "Quay Australia",
      "rabens": "Rabens",
      "radii": "Radii",
      "rains": "Rains",
      "rastaclat": "Rastaclat",
      "rats-get-fat": "Rats Get Fat",
      "rebel-eight": "Rebel Eight",
      "reebok": "Reebok",
      "red-hot-chilli-peppers":"Red Hot Chilli Peppers",
      "red-spot": "Red Spot",
      "regia": "Regia",
      "repja": "Repja",
      "represent": "Represent",
      "retro-kings": "Retro Kings",
      "reuzel": "Reuzel",
      "reves-paris": "Reves Paris",
      "rich-the-kid": "Rich The Kid",
      "roc-nation": "Roc Nation",
      "rocksmith": "Rocksmith",
      "rothco": "Rothco",
      "rustic-dime": "Rustic Dime",
      "saint-morta": "Saint Morta",
      "santa-cruz": "Santa Cruz",
      "select-studios": "Select Studios",
      "serenede": "Serenede",
      "shaun-johnson": "Shaun Johnson",
      "skepta-merch": "Skepta Merch",
      "sik-silk": "Sik Silk",
      "silent-theory": "Silent Theory",
      "simple-watch-co": "Simple Watch Co",
      "ski-mask-the-slump-god": "Ski Mask the Slump God",
      "skulls": "Skulls",
      "sly-guild": "Sly Guild",
      "slayer": "Slayer",
      "slick-gorilla": "Slick Gorilla",
      "sneaker-lab": "Sneaker Lab",
      "sniper-gang": "Sniper Gang",
      "snoop-dogg": "Snoop Dogg",
      "sol-republic": "Sol Republic",
      "ssur": "Ssur",
      "stance": "Stance",
      "standard-issue": "Standard Issue",
      "staple": "Staple",
      "starter": "Starter",
      "status-society": "Status Society",
      "stussy": "Stussy",
      "stussy-usa": "Stussy Usa",
      "super-future": "Super Future",
      "supra": "Supra",
      "supreme": "Supreme",
      "sushi-radio": "Sushi Radio",
      "tans-club": "Tans Club",
      "team-cozy": "Team Cozy",
      "tekashi-69": "Tekashi 69",
      "ten-deep": "Ten Deep",
      "tendence": "Tendence",
      "the-anti-order": "The Anti Order",
      "the-cut": "The Cut",
      "the-cxx": "The Cxx",
      "the-gld-shop": "The GLD Shop",
      "the-hundreds": "The Hundreds",
      "the-man-club": "The Man Club",
      "the-money-team": "The Money Team",
      "the-mountain": "The Mountain",
      "the-quiet-life": "The Quiet Life",
      "thrasher": "Thrasher",
      "tie-dye-usa": "Tie Dye USA",
      "lb2-lil-yachty": "LB2 Lil Yachty",
      "the-wndrr": "WNDRR",
      "thing-thing": "Thing Thing",
      "traplord": "Traplord",
      "thrills": "Thrills",
      "throwback-thursday": "Throwback Thursday",
      "timberland": "Timberland",
      "tits": "Tits",
      "tokidoki": "Tokidoki",
      "tommy-h-watches": "Tommy Hilfiger Watches",
      "tommy-jeans": "Tommy Jeans",
      "traplord-x-ck": "Traplord X Ck",
      "true-fitted": "True Fitted",
      "trukfit": "Trukfit",
      "tupac": "Tupac",
      "ub-by-nar": "Ub By Nar",
      "ultra-force": "Ultra Force",
      "ultra-music-merch": "Ultra Music Merch",
      "uncle-reco": "Uncle Reco",
      "undefeated": "Undefeated",
      "underated-london-ltd": "Underated London Ltd",
      "unyforme": "Unyforme",
      "upper-playground": "Upper Playground",
      "uppercut-deluxe": "Uppercut Deluxe",
      "us-versus-them": "Us Versus Them",
      "vans": "Vans",
      "veritas": "Veritas",
      "versus-versace": "Versus Versace",
      "vitaly": "Vitaly",
      "vsop": "Vsop",
      "wcsp": "Wcsp",
      "wwe-world-wrestling-entertainment": "WWE",
      "well-made": "Well Made",
      "wu-tang-limited": "Wu Tang Brand Limited",
      "wuwear-merch": "Wu Wear",
      "x-large": "X-large",
      "xd-design": "XD Design",
      "xxxtentacion": "XXXTENTACION",
      "yhf-los-angeles": "YHF Los Angeles",
      "yrn": "YRN",
      "yupoong": "Yupoong",
      "zanerobe": "Zanerobe",
      "zoo-york": "Zoo York"
    },
    "gender": {
      "kids": "Kid's",
      "mens": "Men's",
      "youth": "Youth",
      "womens": "Women's"
    },
    "category": {
      "non-stocked-items": "Gifting",
      "purch-music-style-based": "Music Merch",
      "purch-not-for-sale-style-based": "Not For Sale",
      "na": "Mystery Bundles",
      "jewellery": isUS ? 'Jewelry' : 'Jewellery'
    },
    "extraFacets": {
      "sleevedesign": "Sleeve Design",
      "sleevetype": "Sleeve Type",
      "sleevecomposition": "Sleeve Composition",
      "shoulderdesign": "Shoulder Design",
      "shouldertype": "Shoulder Type",
      "waisttype": "Waist Type",
      "waistdesign": "Waist Design",
      "legtype": "Leg Type",
      "leglength": "Leg Length",
      "adjustabletoggles": "Adjustable Toggles",
      "fabriccomposition": "Fabric Composition",
      "fittype": "Fit Type"
    },
    "subcategory": {
      "5-panel": "5 Panels",
      "940-a-frame": "9FORTY A-Frame",
      "940-k-frame": "9FORTY K-Frame",
      "950-high-crown": "9FIFTY High Crown",
      "bandana": "Bandanas",
      "beach-short": "Beach Shorts",
      "bandeau": "Bandeaus",
      "bracelet": "Bracelets",
      "buckets-boonies": "Bucket Boonies",
      "button-up": "Button Ups",
      "caps-accessories": "Cap Accessories",
      "cbr-financial-item": "Gifting",
      "chain": "Chains",
      "crewneck": "Crewnecks",
      "crop": "Crops",
      "dress": "Dresses",
      "face-mask": "Face Masks",
      "fash-fit": "Fash-fits",
      "fedora": "Fedoras",
      "flex-fit": "Flex-fits",
      "golfer": "Old Golfers",
      "hardwood": "Hardwoods",
      "hi-top": "Hi-tops",
      "hood": "Hoodies",
      "jacket": "Jackets",
      "jersey": "Jerseys",
      "jewellery": isUS ? 'Jewelry' : 'Jewellery',
      "jogger": "Joggers",
      "k-frame": "K-Frame",
      "lace": "Laces",
      "ls-tees": "Long Sleeve Tees",
      "misc": "Miscellaneous",
      "muscle-tees": "Muscles",
      "na": "Custom",
      "nfs-costed": "Not For Sale",
      "onfield": "Onfields",
      "original-fit": "Original-fits",
      "outer-wear": "Outerwear",
      "pants-striped": "Striped Track Pants",
      "pendant": "Pendants",
      "replica": "Replicas",
      "rev30": "Rev30s",
      "ring": "Rings",
      "sidebags": "Side Bags",
      "slip-on": "Slip-ons",
      "snapback": "Snapbacks",
      "ss-tees": "Short Sleeve Tees",
      "strapback": "Strapbacks",
      "stretch-fit": "Stretch-fits",
      "tall": "Tall Fit",
      "trackpant": "Track Pants",
      "vinyls": "Vinyls Merch"
    },
    "icon": {
      "tops": "hoodie",
      "women-tops": "women-tee",
      "hood": "hoodie",
      "crewnecks": "crewneck",
      "jacket": "jacket",
      "women-jacket": "women-jacket",
      "outer-wear": "jacket",
      "women-outer-wear": "women-jacket",
      "jersey": "jersey",
      "ss-tees": "tee",
      "women-ss-tees": "women-tee",
      "ls-tees": "ls-tee",
      "women-ls-tees": "women-ls-tee",
      "polos": "button-up",
      "party-shirt": "button-up",
      "button-up": "button-up",
      "women-button-up": "women-button-up",
      "muscle-tees": "singlet",
      "women-muscle-tees": "singlet",
      "crop": "crop-tee",
      "crop-tee": "crop-tee",
      "bodysuit": "women-tee",
      "shirts": "women-button-up",
      "dress": "dress",
      "singlets": "singlet",
      "women-singlets": "women-singlet",
      "crop-singlet": "women-singlet",
      "loungewear-tops": "ls-tee",
      "accessories": "general-accessories",
      "bags": "carry-bag",
      "sidebags": "carry-bag",
      "misc-accessories": "lifestyle",
      "socks": "socks",
      "sunnies": "sunglass",
      "watches": "watch",
      "wallets": "wallet",
      "belts": "belt",
      "chains": "chain",
      "necklace": "chain",
      "bracelet": "chain",
      "ring": "ring",
      "jewellery": "vault",
      "earrings": "vault",
      "pendant": "vault",
      "bottoms": "longs",
      "women-bottoms": "women-longs",
      "kid-bottoms": "shorts",
      "pants": "longs",
      "women-pants": "women-longs",
      "trackpant": "track-pants",
      "jogger": "track-pants",
      "pants-striped": "track-pants",
      "jeans": "longs",
      "women-jeans": "women-longs",
      "shorts": "shorts",
      "women-shorts": "women-short",
      "denim-shorts": "shorts",
      "beach-short": "shorts",
      "basketball-shorts": "shorts",
      "cargo-shorts": "shorts",
      "underwear": "underwear",
      "women-underwear": "women-underwear",
      "leggings": "women-longs",
      "skirt": "skirt",
      "footwear": "shoe",
      "women-footwear": "women-shoe",
      "hi-top": "shoe",
      "women-hi-top": "women-shoe",
      "mids": "shoe",
      "women-mids": "women-shoe",
      "lows": "shoe",
      "women-lows": "women-shoe",
      "slip-on": "slide",
      "purch-music-style-based": "music",
      "onesie": "infant",
      "caps-accessories": "hat",
      "headwear": "hat",
      "face-mask": "mask",
      "living": "lifestyle",
      "lace": "shoe-laces"
    }
  }
}
